const LAST_SEARCH_KEY = 'yubu_last_search_context';

export function getLastSearchContext() {
  try {
    const raw = sessionStorage.getItem(LAST_SEARCH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setLastSearchContext(context) {
  try {
    sessionStorage.setItem(LAST_SEARCH_KEY, JSON.stringify(context));
  } catch {
    // ignore storage failures
  }
}
